package com.wintermar.inspection.core.ui.component.image

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.ColorPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import coil3.compose.AsyncImage
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.image.util.FileModel
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.widget.CircularProgress
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_trash

@Composable
fun Image(
    file: FileModel,
    showDeleteButton: Boolean = false,
    width: Dp = LocalAppTheme.current.dimension.size.size14,
    height: Dp = LocalAppTheme.current.dimension.size.size14,
    onDelete: () -> Unit = {}
) {
    val dimension: AppDimension = LocalAppTheme.current.dimension
    val color: ThemeColor = LocalAppTheme.current.color

    var showPreview by remember { mutableStateOf(false) }
    if (showPreview) {
        ImagePreviewDialog(
            file = file,
            onDismiss = { showPreview = false }
        )
    }

    Box(
        modifier = Modifier.width(width).height(height),
        contentAlignment = Alignment.TopEnd
    ) {
        Row(
            modifier = Modifier.clip(
                shape = RoundedCornerShape(dimension.radius.md)
            ).clickable {
                showPreview = true
            }

        ) {
            AsyncImage(
                model = file.blob ?: file.thumbnailPath.ifBlank { file.path },
                contentDescription = file.name,
                contentScale = ContentScale.FillBounds,
                modifier = Modifier.weight(1f),
                placeholder = ColorPainter(Color.Gray.copy(alpha = 0.3f)),
                error = ColorPainter(Color.Red.copy(alpha = 0.3f)),
            )
        }

        AnimatedVisibility(
            visible = showDeleteButton && file.acceptableToDelete(),
            enter = scaleIn(),
            exit = scaleOut()
        ) {
            Row(modifier = Modifier.padding(dimension.spacing.space2)) {
                IconButton(
                    icon = Res.drawable.ic_trash,
                    backgroundColor = color.surface.normal,
                    tint = color.icon.error.default,
                    onClick = onDelete
                )
            }
        }

        AnimatedVisibility(
            visible = file.isUploading(),
            enter = fadeIn(),
            exit = fadeOut()
        ) {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .background(
                        color = Color.Black.copy(alpha = 0.75f),
                        shape = RoundedCornerShape(dimension.radius.md)
                    )
                    .clip(
                        shape = RoundedCornerShape(dimension.radius.md)
                    ),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                CircularProgress(
                    progress = file.currentUpload?.chunkNumber?.plus(1) ?: 0,
                    total = file.currentUpload?.totalFiles ?: 0
                )
            }
        }
    }
}
